import React from 'react';

const ResultTechIcon = ({ icon, load }) => {
  return (
    <div
      key={icon}
      className={`logotype tech-icon ${icon}`}
      style={{
        background: !load && 'none',
        opacity: load ? 1 : 0,
        transition: 'opacity 300ms linear'
      }}
    />
  );
};

export default ResultTechIcon;

ResultTechIcon.defaultProps = {
  icon: 'vue',
  load: true
}
